<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">This book is lovingly dedicated to Marion</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MoonLookedDown_dedi-1.vue?aed78ed6